import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "input-group input-group-flush input-group-merge input-group-reverse" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "col-auto pe-0"
}
const _hoisted_7 = { class: "col-auto" }

import { ref } from "vue";
import { useRoute } from "vue-router";
import TableFilter from "./TableFilter.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TableSearch',
  props: {
  placeholder: {
    type: String,
    default: "Pesquisar",
  },
},
  emits: ["search"],
  setup(__props, { emit: __emit }) {

const searchInput = ref(useRoute().query.q as string);



const emit = __emit;

const onSearch = () => {
  emit("search", searchInput.value);
};

const handleInput = (event: any) => {
  if (!event.target.value) emit("search", "");
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            id: "table_search_input",
            class: "form-control list-search mt-1",
            type: "search",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInput).value = $event)),
            placeholder: __props.placeholder,
            onKeyup: _withKeys(onSearch, ["enter"]),
            onInput: handleInput
          }, null, 40, _hoisted_5), [
            [_vModelText, searchInput.value]
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "input-group-text" }, [
            _createElementVNode("i", { class: "fa-solid fa-search text-muted" })
          ], -1))
        ])
      ]),
      (_ctx.$slots.filter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(TableFilter, null, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "filter")
              ]),
              _: 3
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Button, {
          onOnClick: onSearch,
          label: "Pesquisar",
          class: "btn-sm",
          outline: "",
          id: "table_search_button"
        })
      ])
    ])
  ]))
}
}

})